import * as St from './NavBar.styles';

import NavBarPricing from '~molecules/NavBarPricing';

type NavBarProps = React.PropsWithChildren;

const NavBar = ({ children }: NavBarProps) => (
  <St.Container>
    {children}
    <St.PricingContainer>
      <NavBarPricing />
    </St.PricingContainer>
  </St.Container>
);

export default NavBar;
